// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.header {
  background-color: var(--surface-light);
  border-bottom: 1px solid var(--border-light);
  padding: 16px 20px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  position: sticky;
  top: 0;
  z-index: 20;
}

.header-title {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 18px;
  font-weight: 700;
  color: var(--text-primary);
}

.header-icon {
  color: var(--primary);
  font-size: 24px;
}

.header-right {
  display: flex;
  align-items: center;
  gap: 12px;
}

.brand-logo {
  width: 32px;
  height: 32px;
  border-radius: 50%;
  overflow: hidden;
  background-color: var(--background-light);
  display: flex;
  align-items: center;
  justify-content: center;
}

.brand-logo img {
  width: 24px;
  height: 24px;
  object-fit: contain;
}

.email-type-indicator {
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 4px 10px;
  border-radius: 6px;
}

.email-type-indicator--outgoing {
  background-color: var(--info-bg);
  border: 1px solid var(--info-border);
}

.email-type-indicator--incoming {
  background-color: var(--success-bg);
  border: 1px solid var(--success-border);
}

.email-type-indicator__icon {
  font-size: 16px;
}

.email-type-indicator--outgoing .email-type-indicator__icon {
  color: var(--info-text);
}

.email-type-indicator--incoming .email-type-indicator__icon {
  color: var(--success-text);
}

.email-type-indicator__label {
  font-size: 11px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.email-type-indicator--outgoing .email-type-indicator__label {
  color: var(--info-text);
}

.email-type-indicator--incoming .email-type-indicator__label {
  color: var(--success-text);
}

@media (max-width: 400px) {
  .header {
    padding: 12px 16px;
  }

  .header-title {
    font-size: 16px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/taskpane/components/Header/Header.css"],"names":[],"mappings":"AAAA;EACE,sCAAsC;EACtC,4CAA4C;EAC5C,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,gBAAgB;EAChB,MAAM;EACN,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA;EACE,qBAAqB;EACrB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,yCAAyC;EACzC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,gCAAgC;EAChC,oCAAoC;AACtC;;AAEA;EACE,mCAAmC;EACnC,uCAAuC;AACzC;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE;IACE,kBAAkB;EACpB;;EAEA;IACE,eAAe;EACjB;AACF","sourcesContent":[".header {\n  background-color: var(--surface-light);\n  border-bottom: 1px solid var(--border-light);\n  padding: 16px 20px;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  position: sticky;\n  top: 0;\n  z-index: 20;\n}\n\n.header-title {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  font-size: 18px;\n  font-weight: 700;\n  color: var(--text-primary);\n}\n\n.header-icon {\n  color: var(--primary);\n  font-size: 24px;\n}\n\n.header-right {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n}\n\n.brand-logo {\n  width: 32px;\n  height: 32px;\n  border-radius: 50%;\n  overflow: hidden;\n  background-color: var(--background-light);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.brand-logo img {\n  width: 24px;\n  height: 24px;\n  object-fit: contain;\n}\n\n.email-type-indicator {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  padding: 4px 10px;\n  border-radius: 6px;\n}\n\n.email-type-indicator--outgoing {\n  background-color: var(--info-bg);\n  border: 1px solid var(--info-border);\n}\n\n.email-type-indicator--incoming {\n  background-color: var(--success-bg);\n  border: 1px solid var(--success-border);\n}\n\n.email-type-indicator__icon {\n  font-size: 16px;\n}\n\n.email-type-indicator--outgoing .email-type-indicator__icon {\n  color: var(--info-text);\n}\n\n.email-type-indicator--incoming .email-type-indicator__icon {\n  color: var(--success-text);\n}\n\n.email-type-indicator__label {\n  font-size: 11px;\n  font-weight: 600;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n}\n\n.email-type-indicator--outgoing .email-type-indicator__label {\n  color: var(--info-text);\n}\n\n.email-type-indicator--incoming .email-type-indicator__label {\n  color: var(--success-text);\n}\n\n@media (max-width: 400px) {\n  .header {\n    padding: 12px 16px;\n  }\n\n  .header-title {\n    font-size: 16px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
